import _objectSpread from "/home/runner/work/utopia-management/utopia-management/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/runner/work/utopia-management/utopia-management/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import "core-js/modules/web.dom.iterable";
import router from "./routers";
import store from '@/store';
import Config from '@/settings';
import NProgress from 'nprogress'; // progress bar

import 'nprogress/nprogress.css'; // progress bar style

import { getToken } from '@/utils/auth'; // getToken from cookie
// import { buildMenus } from '@/api/system/menu'

import { filterAsyncRouter } from '@/store/modules/permission'; // 菜单

import { getMenu } from '@/api/public/menu';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login']; // no redirect whitelist

router.beforeEach(function (to, from, next) {
  if (to.meta.title) {
    document.title = to.meta.title + ' - ' + Config.title;
  }

  NProgress.start();

  if (getToken()) {
    // 已登录且要跳转的页面是登录页
    if (to.path === '/login') {
      next({
        path: '/'
      });
      NProgress.done();
    } else {
      if (store.getters.roles.length === 0) {
        // 判断当前用户是否已拉取完user_info信息
        store.dispatch('GetInfo').then(function (res) {
          // 拉取user_info
          // 动态路由，拉取菜单
          loadMenus(next, to);
        }).catch(function (err) {
          console.log(err);
          store.dispatch('LogOut').then(function () {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        }); // 登录时未拉取 菜单，在此处拉取
      } else if (store.getters.loadMenus) {
        // 修改成false，防止死循环
        store.dispatch('updateLoadMenus').then(function (res) {});
        loadMenus(next, to);
      } else {
        next();
      }
    }
  } else {
    /* has no token */
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next();
    } else {
      next("/login?redirect=".concat(to.fullPath)); // 否则全部重定向到登录页

      NProgress.done();
    }
  }
}); // 递归

var arr = [];

function recursion(data) {
  var delArr = [];
  data.forEach(function (el, index) {
    if (el.permission && el.hidden) {
      arr.push(el.permission);
      delArr.push(index);
    }

    if (el.children) {
      recursion(el.children);
    }
  });
  delArr.reverse();
  delArr.forEach(function (el2) {
    data.splice(el2, 1);
  });
  return arr;
} // 菜单


export function goMenu() {
  return _goMenu.apply(this, arguments);
}

function _goMenu() {
  _goMenu = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getMenu().then(function (res) {
              var arr1 = [];
              var roles = [];

              if (res.rtn_code === 0) {
                arr1 = res.rtn_data.list; // 开启按钮权限
                // roles = recursion(arr1)
                // store.dispatch('setRoles', roles.length ? roles : ['position'])
                // for (var item1 of res.rtn_data) {
                //   var item1_ = {
                //     'name': item1.name,
                //     'path': item1.path,
                //     'hidden': item1.hidden,
                //     'redirect': item1.redirect,
                //     'component': item1.component,
                //     'alwaysShow': item1.alwaysShow,
                //     'meta': item1.meta
                //   }
                //
                //   var arr2 = []
                //   for (var item2 of item1.children) {
                //     var item2_ = {
                //       'name': item2.name,
                //       'path': item2.path,
                //       'hidden': item2.hidden,
                //       'component': item2.component,
                //       'meta': item2.meta
                //     }
                //     arr2.push(item2_)
                //   }
                //
                //   item1_.children = arr2
                //   arr1.push(item1_)
                // }
              }

              return arr1;
            });

          case 2:
            return _context.abrupt("return", _context.sent);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _goMenu.apply(this, arguments);
}

export function loadMenus(_x, _x2) {
  return _loadMenus.apply(this, arguments);
}

function _loadMenus() {
  _loadMenus = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(next, to) {
    var data, asyncRouter;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return goMenu();

          case 2:
            data = _context2.sent;
            // 菜单
            asyncRouter = filterAsyncRouter(data);
            asyncRouter.push({
              path: '*',
              redirect: '/404',
              hidden: true
            });
            store.dispatch('GenerateRoutes', asyncRouter).then(function () {
              // 存储路由
              router.addRoutes(asyncRouter); // 动态添加可访问路由表

              next(_objectSpread(_objectSpread({}, to), {}, {
                replace: true
              }));
            }); // buildMenus().then(res => {
            //   const asyncRouter = filterAsyncRouter(res.rtn_data)
            //   asyncRouter.push({ path: '*', redirect: '/404', hidden: true })
            //   store.dispatch('GenerateRoutes', asyncRouter).then(() => { // 存储路由
            //     router.addRoutes(asyncRouter) // 动态添加可访问路由表
            //     next({ ...to, replace: true })
            //   })
            // })

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _loadMenus.apply(this, arguments);
}

router.afterEach(function () {
  NProgress.done(); // finish progress bar
});
export default router; // 确保导出路由实例